import apiRequest from "./apiConfig";
import { endpoints, apiVersion } from "./endpoints";

export function getAllDistrictsApi(params) {
  let query;
  if (params) {
    query = params;
  } else {
    query = {
      pageSize: 50
    }
  }
  return (apiRequest({
    url: process.env.REACT_APP_API_BASE_URL + apiVersion.version + endpoints.districts,
    method: 'get',
    query
  }));
}

export function getAllZonesApi(params) {
  let query;
  if (params) {
    query = params;
  } else {
    query = {
      pageSize: 25
    }
  }
  return (apiRequest({
    url: process.env.REACT_APP_API_BASE_URL + apiVersion.version + endpoints.zones,
    method: 'get',
    query
  }))
}